import React from 'react';
import QueueAnim from 'rc-queue-anim';
import LoginForm from './components/LoginForm';
import './styles.scss';
import { config } from '../../config';

const Page = () => (
  <QueueAnim type="bottom" className="ui-animate">
    <div key="1">
      <FormCard />
    </div>
  </QueueAnim>
)
const FormCard = () => (
  <section className="form-card-page form-card row no-gutters">
    <div className="form-card__img col-lg-6">
      <img style={{ margin: '8%' }} alt="logo" src={config.IMG_LOGIN} />
    </div>
    <div className="form-card__body col-lg-6 p-5 px-lg-8 d-flex align-items-center">
      <LoginForm />
    </div>
  </section>
)
export default Page;
